var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ReturnOrder = (function (ReturnOrder) {

        ReturnOrder.Messages = (function (Messages) {

            Messages.SubmitOrderReturn = function () {
                var data = {

                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturn', data);
            };
            Messages.SubmitOrderReturn.className = 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturn';


            Messages.SubmitOrderReturnSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturnSuccess', data);
            };
            Messages.SubmitOrderReturnSuccess.className = 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturnSuccess';


            Messages.SubmitOrderReturnsFailed = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturnsFailed', data);
            };
            Messages.SubmitOrderReturnsFailed.className = 'Vendd.OpenAddressEditForm.Messages.SubmitOrderReturnsFailed';


            Messages.OpenAddressEditForm = function (address) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ReturnOrder.Messages.OpenAddressEditForm', address);
            };
            Messages.OpenAddressEditForm.className = 'Vendd.ReturnOrder.Messages.OpenAddressEditForm';


            Messages.GetRequestReturnSuccess = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetRequestReturnSuccess", data);
            };
            Messages.GetRequestReturnSuccess.className = "Vendd.ReturnOrder.Messages.GetRequestReturnSuccess";

            Messages.GetRequestReturnFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetRequestReturnFailure", data);
            };
            Messages.GetRequestReturnFailure.className = "Vendd.ReturnOrder.Messages.GetRequestReturnFailure";

            Messages.GetRequestReturn = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetRequestReturn", data);
            };
            Messages.GetRequestReturn.className = "Vendd.ReturnOrder.Messages.GetRequestReturn";


            Messages.ValidateOrderContactInfo = function (ordercode, phone) {
                var data = {
                    ordercode: ordercode,
                    phone: phone
                }
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.ValidateOrderContactInfo", data);
            };
            Messages.ValidateOrderContactInfo.className = "Vendd.ReturnOrder.Messages.ValidateOrderContactInfo";


            Messages.ValidateOrderContactInfoSuccess = function (orderid) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.ValidateOrderContactInfoSuccess", orderid);
            };
            Messages.ValidateOrderContactInfoSuccess.className = "Vendd.ReturnOrder.Messages.ValidateOrderContactInfoSuccess";


            Messages.ValidateOrderContactInfoFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.ValidateOrderContactInfoFailure", data);
            };
            Messages.ValidateOrderContactInfoFailure.className = "Vendd.ReturnOrder.Messages.ValidateOrderContactInfoFailure";


            Messages.GetReturnRequestValidationFormModel = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModel", data);
            };
            Messages.GetReturnRequestValidationFormModel.className = "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModel";


            Messages.GetReturnRequestValidationFormModelSuccess = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelSuccess", data);
            };
            Messages.GetReturnRequestValidationFormModelSuccess.className = "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelSuccess";

            Messages.GetReturnRequestValidationFormModelFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelFailure", data);
            };
            Messages.GetReturnRequestValidationFormModelFailure.className = "Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelFailure";

            Messages.GetReturnedOrdersModel = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnedOrdersModel", data);
            };
            Messages.GetReturnedOrdersModel.className = "Vendd.ReturnOrder.Messages.GetReturnedOrdersModel";


            Messages.GetReturnedOrdersModelSuccess = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnedOrdersModelSuccess", data);
            };
            Messages.GetReturnedOrdersModelSuccess.className = "Vendd.ReturnOrder.Messages.GetReturnedOrdersModelSuccess";

            Messages.GetReturnedOrdersModelFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ReturnOrder.Messages.GetReturnedOrdersModelFailure", data);
            };
            Messages.GetReturnedOrdersModelFailure.className = "Vendd.ReturnOrder.Messages.GetReturnedOrdersModelFailure";

            return Messages;

        })(ReturnOrder.Messages || {});

        return ReturnOrder;

    })(Vendd.ReturnOrder || {});

    return Vendd;

})(Vendd || {});